import "./App.css";
import Header from "./components/Header";
import Navbar from "./components/Navbar";

// images
import supHeader1 from "./assets/images/sub-header-1.png";
import supHeader2 from "./assets/images/sub-header-2.png";
import free from "./assets/images/free.png";
import currence from "./assets/images/currence.png";
import mic from "./assets/images/mic.png";
import car1 from "./assets/images/car-1.jpg";
import car2 from "./assets/images/car-2.jpg";
import car3 from "./assets/images/car-3.jpg";
import car4 from "./assets/images/car-4.jpg";
import car5 from "./assets/images/car-5.jpg";
import perfectDiv from "./assets/images/perfectDiv.jpg";
import album1 from "./assets/images/album-1.jpg";
import album2 from "./assets/images/album-2.jpg";
import album3 from "./assets/images/album-3.jpg";
import album4 from "./assets/images/album-4.jpg";
import album5 from "./assets/images/album-5.jpg";
import album6 from "./assets/images/album-6.jpg";
import carRace from "./assets/images/race.jpg";
import whats from "./assets/images/whats.png";
import message from "./assets/images/message.png";
import CarItem from "./components/CarItem";
import { useState } from "react";
import Footer from "./components/Footer";

function App() {
  const [cars, setCars] = useState([
    {
      name: "Economy",
      seats: "4",
      suitcase: "2",
      text: "Quite popular with budget travelers visiting the US(usually for short term travel plans), economy cars fall in the category of low-cost rental solutions. Not only inexpensive these rental vehicles are also fuel-efficient.",
      image: car1,
    },
    {
      name: "Luxury",
      seats: "5",
      suitcase: "2",
      text: "Customers visiting America rent luxury cars for business, vacations and other special life occasions like anniversaries. They are used mainly for the comfort and the style quotient they add to the trip.",
      image: car2,
    },
    {
      name: "Convertible",
      seats: "4",
      suitcase: "2",
      text: "Quite popular with budget travelers visiting the US(usually for short term travel plans), economy cars fall in the category of low-cost rental solutions. Not only inexpensive these rental vehicles are also fuel-efficient.",
      image: car3,
    },
    {
      name: "SUV",
      seats: "4",
      suitcase: "2",
      text: "Road trips, filled with activities like camping and water sports, are best planned with SUV rentals. Most families visiting the US, rent SUVs for safe yet luxurious trips to places like Disney World & National Parks like Grand Canyon.",
      image: car4,
    },
    {
      name: "Van/Minivan",
      seats: "7",
      suitcase: "5",
      text: "A van or a minivan rental gives you legroom & luggage space that other car categories don't. On the basis of seating capacity, they are classified as 7-passenger, 8-passenger, 9-passenger, 10-passenger, 12-passenger, and 15-passenger van and minivan rentals.",
      image: car5,
    },
  ]);

  return (
    <main className="App">
      <Navbar />
      <Header />

      {/* Sub Header */}
      <div className="sub-header relative">
        <div className="container md:mx-auto">
          <div className="flex flex-col md:flex-row gap-5 -mt-32 mx-5 md:mx-0">
            <div className="card flex flex-col justify-center items-center md:w-1/3 bg-blue-600 text-slate-100  px-5 py-10 rounded">
              <i class="fa-brands fa-cc-mastercard text-8xl"></i>
              <p className="text-3xl font-bold pt-3">Faster pick-up</p>
              <p className="text-2xl italic text-center pt-5">
                We have your contract already prepared
              </p>
            </div>
            <div className="card flex flex-col justify-center items-center md:w-1/3 bg-green-600 text-slate-100  px-5 py-10 rounded">
              <img src={supHeader1} alt="sub header 1" className="" />
              <p className="text-3xl font-bold pt-3">Faster pick-up</p>
              <p className="text-2xl italic text-center pt-5">
                We have your contract already prepared
              </p>
            </div>
            <div className="card flex flex-col justify-center items-center md:w-1/3 bg-red-600 text-slate-100  px-5 py-10 rounded">
              <img src={supHeader2} alt="sub header 2" className="" />

              <p className="text-3xl font-bold pt-3">Faster pick-up</p>
              <p className="text-2xl italic text-center pt-5">
                We have your contract already prepared
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* ./Sub Header */}
      <hr className="mt-10" />

      {/* Features */}
      <div className="container mx-auto my-16 flex flex-col  items-center md:flex-row gap-5 space-y-5">
        <div className="flex flex-col md:flex-row items-center justify-center  w-full md:w-1/3 ">
          <img src={free} alt="free" className="w-16 mr-5" />
          <p className="text-xl font-semibold">Free Cancellation</p>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center  w-full md:w-1/3 ">
          <img src={currence} alt="currence" className="w-16 mr-5" />
          <p className="text-xl font-semibold">No Hidden Charge</p>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center w-full md:w-1/3 ">
          <img src={mic} alt="mic" className="w-16 mr-5" />
          <p className="text-xl font-semibold">24/7 Customer Support</p>
        </div>
      </div>
      {/* ./Features */}

      {/* give us a call */}
      <div className=" bg-blue-600 text-slate-200 py-28 px-5 md:px-10">
        <div className=" container mx-auto flex flex-col md:flex-row justify-center items-center gap-5 space-y-10 md:space-y-0">
          <div className="w-full md:w-1/2 ">
            <p className=" text-5xl text-center md:text-left">
              Book a car rental near you by giving us a call!
            </p>
          </div>
          <div className="w-full md:w-1/2  text-center">
            <span className=" bg-slate-600 py-5 px-10 text-2xl rounded-full cursor-pointer hover:bg-slate-500 transition">
              +12-345-6789
            </span>
          </div>
        </div>
      </div>
      {/* ./give us a call */}

      {/* car rents */}
      <div className="car-rents py-10 px-5 lg:px-32 md:px-16 flex flex-col items-center justify-center ">
        <h3 className="text-4xl font-semibold tracking-wide">
          Best car & van rentals from top suppliers
        </h3>
        <p className="text-slate-500 text-center italic mt-10 text-lg font-medium">
          Our suppliers provide both automatic and manual transmission vehicles
          in the US, however, availability may vary depending on the supplier
          and the location where you are renting the vehicle.
        </p>

        {/* cars */}
        <div className="cars mt-16 mx-10 md:mx-0">
          {cars.map((car, index) => (
            <CarItem car={car} key={index} />
          ))}
        </div>
        {/* ./cars */}
      </div>
      {/* ./ car rents */}
      {/* deals */}
      <div className="deals flex flex-col items-center px-3 text-center bg-teal-600 text-slate-100 py-28">
        <h4 className="text-4xl font-semibold">
          Best valued deals from top car rental companies in USA
        </h4>
        <p className="text-lg px-0 lg:px-72 text-center my-5">
          In the USA, we have tie-ups with Sixt, Alamo, Europcar, Fox, Dollar,
          National, Hertz Rent-A-Car, Advantage & many others.
        </p>
        <button className="deals-btn mt-5 py-5 px-16 rounded tracking-widest text-lg">
          Learn More
        </button>
      </div>
      {/* ./deals */}

      {/* Perfect */}
      <div className="py-32 px-0 md:px-32">
        <div className="container mx-auto">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="w-full lg:w-1/2 relative">
              <img
                src={perfectDiv}
                alt="perfect"
                className="h-96 w-full lg:absolute lg:h-full lg:w-full lg:-top-20 lg:-right-20 lg:object-cover object-contain"
              />
              <div className="bg-blue-500 h-full w-full block"></div>
            </div>
            <div className="w-full lg:w-1/2 z-30 bg-white px-12 py-8">
              <h3 className="text-5xl font-medium">Rent the perfect car</h3>
              <p className="text-lg font-medium my-5">
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip consequat.
              </p>
              <p className="font-medium text-slate-500 leading-8">
                Duis aute irure dolor in reprehenderit in voluptate velit esse
                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
              <button className="btn bg-blue-500 hover:scale-110 transition duration-200 text-slate-100 rounded-full inline-block w-44 h-16 mt-10 mx-auto md:mx-0">
                Start now
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* ./Perfect */}

      {/* album */}
      <div className="py-10 bg-amber-700">
        <div className="container mx-auto">
          {/* album of photos */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-5">
            <div className="w-full overflow-hidden">
              <img
                src={album1}
                alt="album 1"
                className="w-full h-full hover:scale-110 transition duration-500 cursor-pointer"
              />
            </div>
            <div className="w-full overflow-hidden">
              <img
                src={album2}
                alt="album 1"
                className="w-full h-full hover:scale-110 transition duration-500 cursor-pointer"
              />
            </div>
            <div className="w-full overflow-hidden">
              <img
                src={album3}
                alt="album 1"
                className="w-full h-full hover:scale-110 transition duration-500 cursor-pointer"
              />
            </div>
            <div className="w-full overflow-hidden">
              <img
                src={album4}
                alt="album 1"
                className="w-full h-full hover:scale-110 transition duration-500 cursor-pointer"
              />
            </div>
            <div className="w-full overflow-hidden">
              <img
                src={album5}
                alt="album 1"
                className="w-full h-full hover:scale-110 transition duration-500 cursor-pointer"
              />
            </div>
            <div className="w-full overflow-hidden">
              <img
                src={album6}
                alt="album 1"
                className="w-full h-full hover:scale-110 transition duration-500 cursor-pointer"
              />
            </div>
          </div>

          {/* Travel info */}
          <div className="flex flex-col justify-center items-center text-center py-10 text-slate-50">
            <h3 className="text-5xl mb-5 tracking-wider">
              Car Rental Traveler Information
            </h3>
            <p className="text-lg px-10 md:px-20 lg:px-64">
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
            <button className="btn bg-blue-600 hover:scale-110 transition duration-200 text-slate-100 rounded-full inline-block w-44 h-16 mt-10 mx-auto md:mx-0">
              Learn More
            </button>
          </div>
          {/* ./Travel info */}
        </div>
      </div>
      {/* ./album */}

      {/* car rent from */}
      <div className="pb-10 pt-64 container mx-auto">
        <div className="bg-lime-800 h-52 w-full flex justify-center items-center">
          <img
            src={carRace}
            alt="car race"
            className="w-11/12 md:w-3/4 h-80 object-cover"
          />
        </div>

        {/*  info */}
        <div className="flex flex-col justify-center items-center text-center py-36 text-slate-900">
          <h3 className="text-5xl mb-5 tracking-wider">Car Rentals from $14</h3>
          <p className="text-lg px-10 md:px-20 lg:px-64 text-slate-500">
            Dignissim suspendisse in est ante in nibh mauris. Varius quam
            quisque id diam vel quam elementum pulvinar etiam. Nunc pulvinar
            sapien et ligula ullamcorper malesuada proin. Nunc mattis enim ut
            tellus elementum sagittis vitae et leo.
          </p>
          <button className="btn bg-lime-600 hover:scale-110 font-bold tracking-wider transition duration-200 text-slate-100 rounded-full inline-block w-44 h-16 mt-10 mx-auto md:mx-0">
            Learn More
          </button>
        </div>
        {/* ./ info */}
      </div>
      {/* ./car rent from */}

      {/* Contact */}
      <div className="pb-10">
        <div className="container mx-auto flex flex-col md:flex-row justify-between gap-12">
          <div className="flex flex-col justify-center items-center text-center">
            <img src={whats} alt="whats" className="w-28 object-cover" />
            <p className="text-3xl mt-3">Whatsapp Support</p>
            <p className="mt-5">Add us on WhatsApp & send queries for instant reply.</p>
            <button className="btn bg-green-600 hover:scale-110 font-bold tracking-wider transition duration-200 text-slate-100 rounded-full inline-block w-48 h-16 mt-10 mx-auto md:mx-0">
              +12-345-678-89089
            </button>
          </div>
          <div className="flex flex-col justify-center items-center text-center">
            <img src={message} alt="whats" className="w-28 object-cover" />
            <p className="text-3xl mt-3">Live Chat</p>
            <p className="mt-5">The fastest way to get in touch with an Expert</p>
            <button className="btn bg-orange-600 hover:scale-110 font-bold tracking-wider transition duration-200 text-slate-100 rounded-full inline-block w-48 h-16 mt-10 mx-auto md:mx-0">
             Live Chat
            </button>
          </div>
          <div className="flex flex-col justify-center items-center text-center h-full">
            <p className="text-3xl mt-3 pt-12 pb-3">Manage Booking</p>
            <p className="mt-5">Complete the form to review, cancel or extend your booking.</p>
            <input type='text' placeholder="Enter Email address" className="w-48 h-16 px-5 rounded-full border bg-slate-200 mt-5" />
            <button className="btn bg-blue-600 hover:scale-110 font-bold tracking-wider transition duration-200 text-slate-100 rounded-full inline-block w-48 h-16 mt-2 mx-auto md:mx-0">
             Live Chat
            </button>
          </div>
        </div>
      </div>
      {/* ./Contact */}

      <Footer />
    </main>
  );
}

export default App;
